import { Controller } from "@hotwired/stimulus"

const SPINNER_SVG = `<svg class="w-4 h-4 animate-spin shrink-0" fill="none" viewBox="0 0 24 24">
  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
</svg>`

export default class extends Controller {
  static targets = ["plans"]

  connect() {
    console.log("[billing] connect: targets =", this.hasPlansTarget ? "plans" : "(none)")
  }

  disconnect() {
    console.log("[billing] disconnect")
  }

  showPlans() {
    console.log("[billing] showPlans")
    if (this.hasPlansTarget) {
      this.plansTarget.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  async upgrade(event) {
    const planId = event.params.planId
    console.log("[billing] upgrade: planId =", planId)
    if (!planId) {
      console.error("[billing] upgrade: no planId provided")
      return
    }

    const btn = event.currentTarget
    const originalContent = btn.innerHTML
    btn.classList.add("opacity-50", "pointer-events-none", "inline-flex", "items-center", "gap-2")
    btn.innerHTML = `${SPINNER_SVG}<span>Processing...</span>`

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      const url = `/api/gp/v1/users/stripe/subscribe/${planId}`
      console.log("[billing] fetching:", url)

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })

      console.log("[billing] response:", response.status)
      const data = await response.json()
      console.log("[billing] data:", JSON.stringify(data).substring(0, 200))
      const payload = data.payload || data

      if (payload.redirectUrl || payload.session_url) {
        const redirectTo = payload.redirectUrl || payload.session_url
        console.log("[billing] redirecting to Stripe Checkout:", redirectTo.substring(0, 60) + "...")
        window.location.href = redirectTo
      } else if (data.success) {
        console.log("[billing] free plan upgrade successful, reloading")
        window.location.reload()
      } else {
        console.error("[billing] upgrade failed:", data)
        btn.classList.remove("opacity-50", "pointer-events-none")
        btn.innerHTML = originalContent
      }
    } catch (error) {
      console.error("[billing] error:", error)
      btn.classList.remove("opacity-50", "pointer-events-none")
      btn.innerHTML = originalContent
    }
  }
}
